export default "__VITE_ASSET__DJEpcq76__"